<form [formGroup]="formGroup" class="flex gap-2">
  <mat-form-field appearance="outline" class="w-full md:w-80">
    <mat-label>Listar Faturas</mat-label>
    <mat-select formControlName="statuses" multiple>
      <mat-option value="today">HOJE</mat-option>
      <mat-option value="overdue">VENCIDO</mat-option>
      <mat-option value="parcial">PARCIAL</mat-option>
      <mat-option value="open">ABERTO</mat-option>
      <mat-option value="payed">PAGO</mat-option>
      <mat-option value="agreement">ACORDO</mat-option>
      <mat-option value="negative">NEGATIVADO</mat-option>
      <mat-option value="protest">PROTESTO</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-full md:w-80">
    <mat-label>Selecione o periído de vencimento</mat-label>
    <mat-date-range-input
      [rangePicker]="picker"
    >
      <input
        matStartDate
        formControlName="dateStart"
        placeholder="Data inicial"
      />
      <input
        matEndDate
        formControlName="dateEnd"
        placeholder="Data final"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</form>
